import React, {ReactNode} from "react"
import {FavouritesBadge as Badge} from "./component"

export type ClubBadgeProps = {
    hideBadge: boolean
    children: ReactNode
}

export const ClubBadge = ({hideBadge, children}: ClubBadgeProps) => {
    return (
        <Badge
            variant="dot"
            invisible={hideBadge}
            overlap="circular"
            data-testid={`header-fav-badge-${`${hideBadge ? "in" : ""}active`}`}
        >
            {children}
        </Badge>
    )
}

export default ClubBadge
